import { render, staticRenderFns } from "./turntableList.vue?vue&type=template&id=04b258ca&scoped=true"
import script from "./turntableList.vue?vue&type=script&lang=js"
export * from "./turntableList.vue?vue&type=script&lang=js"
import style0 from "./turntableList.vue?vue&type=style&index=0&id=04b258ca&prod&lang=scss&scoped=true"
import style1 from "./turntableList.vue?vue&type=style&index=1&id=04b258ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b258ca",
  null
  
)

export default component.exports